import React, {FC, useState} from "react";
import style from "./HeaderTop.module.css";
import {Logo} from "./Logo/Logo";
import {LoginIcon} from "./LoginIcon/LoginIcon";
import {LanguageSelect} from "./LanguageSelect/LanguageSelect";
import {useAppSelector} from "../../../../hooks/redux";
import {getIsAuth} from "../../../../store/selectors/authSelector";
import {MenuOutlined} from "@ant-design/icons";
import Menu from "./Menu/Menu";
import ProfileLink from "./ProfileLink/ProfileLink";

export const HeaderTop: FC = () => {
    const isAuth = useAppSelector(getIsAuth)

    const [isMenuShown, setIsMenuShown] = useState(false)



    const showMenu = () => {
        setIsMenuShown(true)
    }

    return <div className={style.headerTopWrapper}>
        <MenuOutlined className={style.menu} onClick={showMenu}/>
        <Menu setIsMenuShown={setIsMenuShown} isMenuShown={isMenuShown}/>
        <Logo/>
        <div className={style.headerTopRightBlock}>
            {isAuth ? <ProfileLink/> : <LoginIcon/>}
            <div className={style.languageWrapper}><LanguageSelect/></div>
        </div>
    </div>
};